import React from 'react'
import { numberWithSpaces } from '../../../utils/NumberWithSpaces'

export default function CardCreditTotal({t,creditotal}) {
  return (
    <div className="card box-shadow-0 mb-lg-0">
      <div className="card-body">
        <div className="item-box text-center">
        <div className="bg-primary-transparent icon-bg icon-service text-azure">
        <i className="fa fa-university" />
       </div>
          <div className="item-box-wrap">
            <p className="text-muted  pmobiletext mb-0">{isNaN(creditotal) ? 0 : numberWithSpaces(parseFloat(creditotal).toFixed(3))}</p>
            <h6 className=" mobiletext mb-2"  style={{fontSize:"12px"}}> {t('releve.totcredit')} </h6>
          </div>
        </div>
      </div>
    </div>
  )
}
